module.exports = __webpack_public_path__ + "media/promo/promo/images/bg-2-468bde64b1386985afdce21d6d282057.png";